import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import MessageSettingsService from 'cio/services/message-settings';
import Transition from '@ember/routing/-private/transition';

export default class ActionsMessagingLimit extends Route {
  @service messageSettings!: MessageSettingsService;

  crumb() {
    return {
      name: 'Message Limit',
      path: 'actions.messaging_limit',
    };
  }

  async afterModel(model: unknown, transition: Transition) {
    await this.messageSettings.loadMessagingLimit.perform();

    return super.afterModel(model, transition);
  }
}
